// extracted by mini-css-extract-plugin
module.exports = {"content":"App_content__2oTig","extension":"App_extension__3aCRP","padding":"App_padding__1OJoF"};